import { Text, VFlow } from 'bold-ui'
import React from 'react'

import { NewsHeadingSection } from './NewsHeadingSection'

export function NewsInternalEstabilizacaoV43() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 4.3.14' subtitle=' | 07/03/2022'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de cenário em que o ano de 2021 não era exibido corretamente no filtro do relatório de situação do
            território.
          </Text>
          <Text component='li'>Correção de erro que podia interromper a transmissão de dados.</Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.13' subtitle=' | 07/02/2022'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro onde não era possível confirmar registros não relacionados a Covid-19 nas fichas de
            vacinação no CDS.
          </Text>
          <Text component='li'>
            Correção de cenário onde alguns filtros aplicados nos relatórios de produção de vacinação não estavam
            funcionando corretamente.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.12' subtitle=' | 03/02/2022'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Inclusão do imunobiológico "Covid-19 - Pfizer/Biontech (Comirnaty) - Pediátrica".</Text>
          <Text component='li'>
            Inclusão de novos grupos para o atendimento de vacinação: "Pessoas de 5 a 11 anos", "Crianças quilombolas",
            "Crianças ribeirinhas" e "Crianças indígenas".
          </Text>
          <Text component='li'>
            Adaptação dos grupos rápidos da FAOI, possibilitando o cadastro dos seguintes procedimentos SIGTAP
            "02.04.01.022-5 - RADIOGRAFIA PERIAPICAL", "03.07.01.012-0 - RESTAURAÇÃO DE DENTE PERMANENTE POSTERIOR COM
            RESINA COMPOSTA" e "02.04.01.021-7 - RADIOGRAFIA INTERPROXIMAL (BITE WING)".
          </Text>
          <Text component='li'>
            Correção de erro onde o CPF do usuário gerador não estava sendo exibido nos registros de autenticação com
            sucesso do módulo de auditoria.
          </Text>
          <Text component='li'>
            Correção de erro que impedia as medições de serem salvas na sincronização com o aplicativo Atenção
            Domiciliar.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.10' subtitle=' | 03/01/2022'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro que impedia a finalização de atendimentos com solicitação de exames.
          </Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.9' subtitle=' | 14/12/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Adição do procedimento SIGTAP "01.01.04.009-1 DISPENSAÇÃO DE SUPLEMENTO DE MICRONUTRIENTES EM PÓ -
            NUTRISUS".
          </Text>
          <Text component='li'>
            Correção de erro na impressão do Relatório operacional de risco cardiovascular, onde todos os cidadãos eram
            apresentados com a mesma microárea.
          </Text>
          <Text component='li'>
            Alteração da caixa de seleção de municípios para que municípios com nomes muito pequenos sejam exibidos
            corretamente.
          </Text>
          <Text component='li'>Inclusão do filtro referente a Microárea no Acompanhamento de condições de saúde.</Text>
          <Text component='li'>Ajustes gerais visando performance.</Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.8' subtitle=' | 19/11/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Ajustes na vacina de PENTAinativada. Agora é possível realizar aplicações e aprazamentos com este
            imunobiológico.
          </Text>
          <Text component='li'>
            Correção de cenário onde não estava sendo apresentada a mensagem de usuário ou senha incorretos na tela de
            acesso.
          </Text>
          <Text component='li'>Ajustes e melhorias nas visualizações dos rascunhos do CDS.</Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.7' subtitle=' | 08/11/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Correção de erro ao usar o filtro Categoria profissional nos relatórios de procedimentos individualizados em
            bases com banco de dados Oracle.
          </Text>
          <Text component='li'>
            Correção de cenário onde não era possível atualizar o cadastro de um cidadão caso este fosse vinculado a uma
            equipe diferente da equipe utilizada pelo profissional.
          </Text>
          <Text component='li'>
            Correção de erro no módulo de Unificação de cadastros quando se tentava fazer duas unificações seguidas.
          </Text>
          <Text component='li'>Ajustes gerais visando performance.</Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.6' subtitle=' | 20/10/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>Correção de erro que impossibilitava o processamento de relatórios.</Text>
        </VFlow>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 4.3.5' subtitle=' | 14/10/2021'>
        <VFlow vSpacing={0.5}>
          <Text component='li'>
            Adição da opção de "Excluir atendimento de vacinação" na tela do histórico. A retificação de atendimentos de
            vacinação deve ser feita excluindo o atendimento e fazendo um novo registro utilizando a ficha de vacinação
            do CDS.
          </Text>
          <Text component='li'>
            Adição das opções "Excluir ficha processada" e "Retificar" na ficha de vacinação. A opção "Retificar"
            permite gerar um novo registro corrigindo informações que já foram processadas e enviadas.
          </Text>
          <Text component='li'>
            Correção de cenário onde não era possível visualizar o histórico de alguns atendimentos de pré-natal.
          </Text>
          <Text component='li'>
            Revisão do comportamento dos filtros da lista de atendimentos, modificando a persistência e melhorando a
            performance.
          </Text>
          <Text component='li'>
            Correção de erro onde o botão "Ver somente os meus atendimentos" não estava se comportando corretamente.
          </Text>
        </VFlow>
      </NewsHeadingSection>
    </VFlow>
  )
}
